import { inferRouteObject } from 'react-router-typed-object';

import { ClickPreview } from 'src/scenes/ClickPreview';

export const clickPreviewRouteObject = inferRouteObject({
  path: 'click-preview',
  Component: ClickPreview,
});
